<template>
  <div>
    <div
      v-for="(category, index) in categories"
      :key="index"
      class="lf-modal-wrapper__sidebar-item"
      :class="{
        'lf-modal-wrapper__sidebar-item--active': activeCategory === category.id
      }"
      @click.stop="onSetActiveCategory(category.id)"
    >
      <span class="lf-modal-wrapper__sidebar-item-text">
        {{ category.label }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { APICategory } from '@/components/components/editing/Modals/interfaces';

export default defineComponent({
  name: 'ModalSidebarCategories',
  props: {
    categories: Array as PropType<APICategory[]>,
    activeCategory: {
      type: [String, Number], //Can be 'all' or a number (id)
      default: 'all'
    }
  },
  emits: ['setActiveCategory'],
  setup(props, context) {
    const onSetActiveCategory = (id: number | string) => {
      context.emit('setActiveCategory', id);
    };

    return {
      onSetActiveCategory
    };
  }
});
</script>
